import { GroupByDates } from '@/services/api/resources/analytics/types';

const startsDaysBefore = n => {
  const start = new Date();
  start.setHours(0, 0, 0);
  start.setDate(start.getDate() - n);
  return start;
};

const startsLast30Days = () => startsDaysBefore(30);

const endsToday = () => {
  const end = new Date();
  end.setHours(0, 0, 0);
  end.setDate(end.getDate() + 1);
  end.setSeconds(end.getSeconds() - 1);
  return end;
};

const DAY = 60 * 60 * 24;

const chartGroupBy = duration => {
  if (duration < 14 * DAY) {
    return GroupByDates.Day;
  }
  if (duration < 60 * DAY) {
    return GroupByDates.Week;
  }
  return GroupByDates.Month;
};

export {
  startsDaysBefore,
  startsLast30Days,
  endsToday,
  chartGroupBy,
};
